import React, { useState, useEffect } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import tycoonHeader from "./media/images/tycoonland_header_image.jpeg";

const Return: React.FC = () => {
  const [status, setStatus] = useState<string | null>(null);
  const [customerEmail, setCustomerEmail] = useState<string>("");
  const navigate = useNavigate();

  useEffect(() => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const sessionId = urlParams.get("session_id");

    if (!sessionId) return;

    fetch(`https://apiv2.tycoonland.nyc/api/stripe/webhooks/session-status?session_id=${sessionId}`)
      .then((res) => res.json())
      .then((data: { status: string; customer_email: string }) => {
        setStatus(data.status);
        setCustomerEmail(data.customer_email);
      })
      .catch((err) => {
        console.error("Error fetching session status:", err);
      });
  }, []);

  useEffect(() => {
    if (status === "complete") {
      const timer = setTimeout(() => {
        localStorage.removeItem("cart");
        navigate("/");
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [status, navigate]);

  if (status === "open") {
    return <Navigate to="/checkout" />;
  }

  if (status === "complete") {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
          textAlign: "center",
          padding: "1rem"
        }}
      >
        <img
          src={tycoonHeader}
          alt="Tycoonland Header"
          style={{ maxWidth: "400px", width: "100%", marginBottom: "2rem" }}
        />
        <h2 style={{ marginBottom: "1rem" }}>Thank you for your purchase!</h2>
        <p style={{ maxWidth: "600px", marginBottom: "1.5rem" }}>
          A confirmation email will be sent to <strong>{customerEmail}</strong>.
          <br />
          If you have any questions, please email{" "}
          <a href="mailto:support@tycoonland.nyc">support@tycoonland.nyc</a>.
        </p>
        <button
          onClick={() => {
            localStorage.removeItem("cart");
            navigate("/");
          }}
          style={{
            padding: "0.75rem 1.5rem",
            fontSize: "1rem",
            borderRadius: "8px",
            backgroundColor: "#000",
            color: "#fff",
            border: "none",
            cursor: "pointer"
          }}
        >
          Continue Shopping
        </button>
      </div>
    );
  }

  return null;
};

export default Return;
